import React, { Component } from 'react';
import GeneralPage from './GeneralPage'

class PrivacyPage extends Component {
  render() {
    window.document.querySelector('html').classList.add('ready');
    return (
      <GeneralPage 
        enUID="privacy-policy"
        frUID="declaration-de-confidentialite"
      />
    )
  }
}

export default PrivacyPage


// WEBPACK FOOTER //
// ./src/pages/PrivacyPage.js